function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AngularFormUtilities } from 'invision-core';
import LocaleKeys from '../../../../../locales/keys';
import { updateServiceFriendlyName } from '../dbss.dashboard.actions';
var UpdateServiceFriendlyNameModalController = /*#__PURE__*/function () {
  function UpdateServiceFriendlyNameModalController($ngRedux, $timeout) {
    _classCallCheck(this, UpdateServiceFriendlyNameModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout
    });
  }
  return _createClass(UpdateServiceFriendlyNameModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.localeKeys = LocaleKeys;
      this.MAX_NAME_LENGTH = 200;
      this.newFriendlyName = this.serviceIdentifier.FriendlyName;
      var mapStateToTarget = function mapStateToTarget() {
        return {};
      };
      var controllerActions = {
        updateServiceFriendlyName: updateServiceFriendlyName
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.onClose()();
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var _this2 = this;
      this.$timeout(function () {
        _this2.formErrors = AngularFormUtilities.constraintErrorMessages(undefined, _this2.friendlyNameForm, {
          friendlyName: LocaleKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.LABEL
        }, {
          maxlength: {
            friendlyName: _this2.MAX_NAME_LENGTH
          }
        });
      });
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      var _this3 = this;
      if (this.friendlyNameForm.$valid) {
        this.isUpdating = true;
        this.actions.updateServiceFriendlyName(this.customerId, this.serviceIdentifier.Value, this.newFriendlyName).then(function () {
          _this3.onSubmit()();
          _this3.isUpdating = false;
        }, function (error) {
          _this3.formErrors = [error.translatedMessage];
          _this3.isUpdating = false;
        });
      } else {
        this.validateForm();
      }
    }
  }]);
}();
export default {
  template: require('./update.friendly.name.modal.html'),
  controller: UpdateServiceFriendlyNameModalController,
  bindings: {
    onClose: '&',
    onSubmit: '&',
    customerId: '<',
    serviceIdentifier: '<'
  }
};